import $api from "../http";
import { AxiosResponse } from "axios";
import { IControlAdmin, IUsers } from "../models/IUsers";
import { ApiResponse, UserEnquiry } from "../models/IPages";
import { IUser } from "../models/IUser";

export default class UsersService {
  static async fetchList(status: string[]): Promise<AxiosResponse<IUsers>> {
    const url = "=" + status.join("+");
    return await $api.get<IUsers>(`/clients?status${url}`);
  }

  static async fetchOne(id: string | undefined): Promise<AxiosResponse<any>> {
    return await $api.get<any>(`/clients/${id}`);
  }

  static async fetchUpdateOne(data: IUsers): Promise<AxiosResponse<boolean>> {
  return await $api.post<boolean>("/clients", data);
  }

  static async fetchDeleteOne(
    id: string | undefined
  ): Promise<AxiosResponse<boolean>> {
    return await $api.delete<boolean>(`/clients?id=${id}`);
  }

  static async fetchStatistics(): Promise<AxiosResponse<IUsers>> {
    return await $api.get<IUsers>("/clients/statistics");
  }

  static async updateDoc(data: any): Promise<AxiosResponse<boolean>> {
    return await $api.post<boolean>("/clients/docs", data);
  }

  // TODO: Admin Doc Section
  static async uploadAdminDoc(data: any): Promise<AxiosResponse<boolean>>{
    return await $api.post<boolean>(
    "/clients/adminDoc",
    data, 
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  }

  static async updateAdminDoc(data: any): Promise<AxiosResponse<boolean>>{
    return await $api.put<boolean>(
    "/clients/updateDoc", 
    data, 
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  }

  static async deleteAdminDoc(data: any): Promise<AxiosResponse<boolean>>{
    return await $api.put<any>(
    "/clients/deleteDoc", 
    data
    )
  
  }

  // TODO: user Calculator is there.
  static async calcDeleteData(data: any): Promise<AxiosResponse<boolean>>{
    return await $api.put<any>(
    "/calculators/deleteDoc", 
    data
    )
  }
  
  static async fetchUserEnquiry(): Promise<AxiosResponse<ApiResponse>> {
    return await $api.get<ApiResponse>("/page-management/getAllEnquiries");
  }

  static async deleteUserEnquiry(id: any): Promise<AxiosResponse<boolean>> {
    return await $api.delete<any>(`/page-management/deleteEnquiry/${id}`);
  }

  static async userProfile(id: string, data: any): Promise<AxiosResponse<IUser>> {
    return await $api.patch<any>(`/user/updateProfile/${id}`, data);
  }
  static async deleteAppliction(index:number): Promise<AxiosResponse<IUser>> {
    return await $api.delete<any>(`/user/deleteApplication/${index}`);
  }
}